import { cloneElement } from "react";
import { tokens } from "../../../theme";
import { Box, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import CommitRow from "./CommitRow";
import { releaseStyles } from "../styles";
import { plural, repoCount, tagRange } from "./releaseViewHelpers";

const RELEASE_COLUMNS = [
  "Repository",
  "Tag",
  "Ticket",
  "Message",
  "Flag",
  "PR",
];

const repoLabel = (count) =>
  `${count} ${count === 1 ? "repository" : "repositories"}`;

// One patch/service block with a flat commit table.
// columns + renderRow can be overridden by the Service view; defaults give the Release view.
const PatchBlock = ({
  patch,
  open,
  onToggle,
  columns = RELEASE_COLUMNS,
  renderRow,
  headerRowSx,
  chips,
  sx,
}) => {
  const theme = useTheme();
  const { releaseView } = releaseStyles(tokens(theme.paletteId));

  const commits = patch.commits;
  const repositories = repoCount(commits);
  const doubles = commits.filter((commit) => commit.isDouble).length;

  const headerSx = headerRowSx || releaseView.headerRow;
  const rowRenderer = renderRow || ((commit) => <CommitRow commit={commit} />);

  return (
    <Box sx={[releaseView.patchBlock, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Box
        component="button"
        type="button"
        sx={releaseView.patchHeader}
        onClick={onToggle}
      >
        <ChevronRight sx={releaseView.patchChevron(open)} />
        <Typography component="span" sx={releaseView.patchLabel}>
          {patch.label}
        </Typography>
        {chips ? (
          chips
        ) : (
          <>
            <Box component="span" sx={releaseView.patchCount(false)}>
              {repoLabel(repositories)}
            </Box>
            <Box component="span" sx={releaseView.patchCount(false)}>
              {plural(commits.length, "total commit")}
            </Box>
            <Box component="span" sx={releaseView.patchCount(true)}>
              {doubles} double
            </Box>
          </>
        )}
        <Typography component="span" sx={releaseView.patchRange}>
          {tagRange(commits)}
        </Typography>
      </Box>

      {open && commits.length ? (
        <>
          <Box sx={headerSx}>
            {columns.map((col) => (
              <Typography
                key={col}
                sx={{
                  ...releaseView.headerCell,
                  justifySelf: col === "PR" ? "end" : "start",
                }}
              >
                {col}
              </Typography>
            ))}
          </Box>

          {commits.map((commit) =>
            cloneElement(rowRenderer(commit), { key: commit.id })
          )}
        </>
      ) : null}
    </Box>
  );
};

export default PatchBlock;
